export default {"src":"/_next/static/media/mobi.c35bd8a1.svg","height":124,"width":138,"blurWidth":0,"blurHeight":0};